import styled from "styled-components";
import { GENDER } from "~/src/consts";
import { COLORS } from "~/src/styles/config.style";

export const StyledInfoBox = styled.div`
  margin-top: 3px;
  padding: 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  background-color: #A3CAFF;
  border-radius: 6px;

  & a {
    color: white;
    font-weight: 800;
  }
}`;

export const ScrapeLink = styled.span`
  display: inline-block;
  position: relative;
  color: white;
  width: 180px;
  height: 32px;
  font-size: 14px;

  cursor: pointer;

  background-color: ${COLORS.MAIN_ORANGE};
  border-radius: 10px;

  padding: 5px 10px;
  margin: 5px 5px 0 0;

  &.selected {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.MAIN_ORANGE};
  }

  &::after {
    content: "🔍";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

export const ScrapeGender = styled.span`
  position: absolute;
  right: 30px;
  top: 50%;
  font-size: 120%;
  color: ${COLORS.MAIN_ORANGE};
  background-color: white;
  font-weight: bold;
  text-align: center;
  transform: translateY(-50%);
  pointer-events: none;
  border-radius: 11px;
  width: 22px;

  &::after {
    content: "${({ gender }) =>
      gender === GENDER.MALE ? "♂" : gender === GENDER.FEMALE ? "♀" : ""}";
  }
`;

export const ProviderLink = styled.div`
  color: white;
  white-space: nowrap;
  text-align: left;
  margin-top: 5px;
  cursor: pointer;

  & p {
    font-size: 110%;
    margin: 0;
    padding: 0;
  }
`;

export const SourceRefs = styled.div``;

export const ScrapeBox = styled.div`
  background-color: white;
  border: solid 1px white;
  margin-top: 5px;
`;

export const ImgOverflow = styled.div`
  overflow-x: auto;

  & img {
    width: 100%;
    cursor: zoom-in;
  }

  & img.expanded {
    width: auto;
    cursor: zoom-out;
  }
`;
